import { Avatar } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import useStyles from './Image.styles';
import { FindingShape } from '../../../finding/models/Finding';
import useAgent from '../../hooks/useAgent';
import findingAgent from '../../../finding/agents/findingAgent';

const Image = ({ isVisible, patrolId, finding }) => {
  const classes = useStyles();
  const [fetchImage, imageResult] = useAgent(findingAgent.getFindingImage);
  const [isManualIcon, setIsManualIcon] = React.useState(false);

  useEffect(() => {
    if (isVisible && !imageResult) fetchImage(patrolId, finding.id);
  }, [isVisible, imageResult, fetchImage, finding, patrolId]);

  const imageUrl = imageResult?.imagePath;

  useEffect(() => {
    if (imageUrl) {
      const img = new window.Image();
      img.src = imageUrl;
      img.onload = () => {
        if (img.width <= 128 && img.height <= 128) {
          setIsManualIcon(true);
        } else {
          setIsManualIcon(false);
        }
      };
    }
  }, [imageUrl]);

  if (!imageResult || !imageResult.imagePath) return <Avatar variant="square" className={classes.image} />;

  const imageClass = isManualIcon ? classes.overriddenImage : classes.image;

  return <img alt="" src={imageUrl} className={imageClass} />;
};

Image.propTypes = {
  isVisible: PropTypes.bool,
  patrolId: PropTypes.number.isRequired,
  finding: FindingShape.isRequired,
};

Image.defaultProps = {
  isVisible: true,
};

export default React.memo(Image);
